module.exports = __webpack_public_path__ + "static/media/LT1A1B成像模式.0164e33f.jpg";